<template>
  <div class="row">
    <div class="col-12">
      <code v-if="debug">
        {{ data }}
        <hr />
        {{ model }}
      </code>
      <div>
        <b-form-group label="Kiosk Name" :disabled="false">
          <v-select v-model="model.KioskName" :options="kiosks" label="KioskName" :reduce="k => k.KioskName"></v-select>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Day of the Week" :disabled="false">
          <v-select v-model="model.DayOfWeek" :options="options" :reduce="d => d.code"></v-select>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Event Time" :disabled="false">
          <b-time v-model="timeModel.EventTime" :hour12="false"></b-time>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Kiosk State" :disabled="false">
          <div class="toggleWrapper">
            <input
              id="KioskState"
              v-model="boolsSwitches.KioskState"
              class="dn"
              type="checkbox"
            />
            <label class="toggle" for="KioskState"
              ><span class="toggle__handler"></span
            ></label>
          </div>
        </b-form-group>
      </div>
    </div>
    <hr />
    <div class="col-12 bt-1">
      <b-button variant="success" class="mr-1" @click="save">Save</b-button>
      <b-button variant="success" @click="saveAndClose"
        >Save &amp; Close</b-button
      >
      <b-button variant="secondary" class="ml-1" @click="cancel"
        >Cancel</b-button
      >
    </div>
  </div>
</template>

<script>
import NotificationMixin from '@mixins/notificationMixin.js'
import CancelMixin from '@mixins/cancel.js'
export default {
  mixins: [NotificationMixin, CancelMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    contentType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debug: false,
      options: [
        {
          label: 'ALL',
          code: -1,
        },
        {
          label: 'MON',
          code: 1,
        },
        {
          label: 'TUE',
          code: 2,
        },
        {
          label: 'WED',
          code: 3,
        },
        {
          label: 'THU',
          code: 4,
        },
        {
          label: 'FRI',
          code: 5,
        },
        {
          label: 'SAT',
          code: 6,
        },
        {
          label: 'SUN',
          code: 7,
        },
      ],
      boolsSwitches: {
        KioskState: false,
      },
      timeModel: {
        EventTime: '00:00',
      },
      model: {
        OperatingTimeId: null,
        KioskName: null,
        DayOfWeek: null,
        EventTime: null,
        KioskState: null,
      },
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        if (data) this.mapData(data)
      },
    },
    boolsSwitches: {
      deep: true,
      handler(bools) {
        // The server model uses T/F rather than bools!
        this.model.KioskState = bools.KioskState ? 'ON' : 'OFF'
      },
    },
  },
  computed: {
    saveEnabled() {
      return true
    },
    kiosks() {
      return this.$store.getters['Kiosks/list']
    }
  },
  beforeCreate() {
    const depData = ['Kiosks']
    depData.forEach((key) => {
      this.$store.dispatch(`${key}/all`)
    })
  },
  methods: {
    mapData(dataIn) {
      //   Take the server data and apply it to our model
      this.model.OperatingTimeId = dataIn.OperatingTimeId
      this.model.KioskName = dataIn.KioskName
      this.model.DayOfWeek = dataIn.DayOfWeek
      this.model.EventTime = dataIn.EventTime
      this.model.KioskState = dataIn.KioskState

      this.boolsSwitches.KioskState = dataIn.KioskState === 'ON'

      const time = dataIn.EventTime.match(/([0-9]{2}:[0-9]{2}:[0-9]{2})/)

      this.timeModel.EventTime = time[0]
    },

    async save() {
      if (!this.saveEnabled) {
        return
      }
      let id, type
      if (this.data) {
        id = this.data[this.contentType.idKey]
        type = 'patch'
      } else {
        id = 0
        type = 'post'
      }
      try {
        // Uppercase
        this.model.KioskName = this.model.KioskName.toUpperCase()
        const trimTime = this.timeModel.EventTime.match(/([0-9]{2}:[0-9]{2})/)
        this.model.EventTime = trimTime[0]
        if (!this.model.KioskState) {
          this.model.KioskState = 'OFF'
        }
        await this.$store.dispatch(`${this.contentType.name}/${type}`, {
          id: id,
          body: this.model,
        })
        this.showNotification('Saved successfully', 'success')
      } catch (error) {
        this.showNotification(error, 'error')

        throw new Error(error)
      }
    },
    async saveAndClose() {
      if (!this.saveEnabled) {
        return
      }
      try {
        await this.save()
      } catch (error) {
        window.console.log(error)
        return
      }
      this.$router.push(`/${this.contentType.name}/list`)
    },
  },
}
</script>
